import React, { useState } from 'react';
import { Image } from 'components/UI/image';
import {
  lockDarkIcon,
  logoutIcon,
  parasitionLogo,
  warnerSwedenIcon,
} from 'resources/images';
import { Constants } from 'utils/constants';
import { Button } from 'components/UI/button';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from 'hooks/useauthcontext';
import styles from './styles.module.css';
import Avatar from 'components/UI/avatar';
import classNames from 'classnames';
import PopOver from 'components/UI/popover';
import Input from 'components/UI/input';
import { updatePasswordApi } from 'networking/apis/user';
import { useToastHook } from 'hooks/usetoasthook';

const Header = () => {
  // CONSTANTS

  const { routeNames, menuData } = Constants();
  const { userData } = useAuthContext();
  const { showToast } = useToastHook();

  // ROUTING
  const navigate = useNavigate();
  const location = useLocation();

  const [profileRef, setProfileRef] = useState();
  const [profileOpen, setProfileOpen] = useState(false);
  const [passwordChangeOpen, setPasswordChangeOpen] = useState(false);
  const [passwordChangeRef, setPasswordChangeRef] = useState();
  const [password, setPassword] = useState('');
  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('loggedIn');
    localStorage.removeItem('userData');
    navigate(routeNames.login);
  };

  const handlePasswordChange = async () => {
    try {
      if (!userData?._id) {
        showToast.error('Please login to update password');
        return;
      }
      const response = await updatePasswordApi(userData?._id, {
        password,
      });

      showToast.success(response?.data?.message, 'success');
      setPasswordChangeOpen(false);
      setPassword('');
    } catch (error) {
      showToast.error(error?.response?.data?.message, 'error');
    }
  };

  const renderLogoAndMenu = () => {
    return (
      <div className={styles.logo_menu_section}>
        <Image
          image={parasitionLogo}
          altText="parasitionLogo"
          onClick={() => navigate(routeNames.createCampaign)}
          customImageContainerStyle={styles.header_logo}
        />
        <div className={styles.header_menuContainer}>
          {menuData?.map((menuItem, index) => (
            <h5
              key={index}
              className={
                location.pathname === menuItem.route
                  ? styles.header_activeMenuItem
                  : styles.header_inActiveMenuItem
              }
              onClick={() => navigate(menuItem?.route)}
            >
              {menuItem?.name}
            </h5>
          ))}
        </div>
      </div>
    );
  };

  const renderPasswordChangePopup = () => {
    return (
      <PopOver
        reference={passwordChangeRef}
        show={passwordChangeOpen}
        showOverlay
        containerStyle={styles.passwordChangePopupStyle}
        onClose={() => setPasswordChangeOpen(false)}
      >
        <div className={styles.passwordChangeHeaderStyle}>
          <Image
            image={lockDarkIcon}
            altText="change password"
            customImageContainerStyle={styles.profileIconStyle}
          />
          <p>Update password</p>
        </div>
        <Input
          label="Enter new password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          title="Update password"
          onClick={handlePasswordChange}
          disabled={!password}
          classname={styles.passwordChangeBtnStyle}
        />
      </PopOver>
    );
  };

  const renderProfilePopSection = () => {
    return (
      <PopOver
        reference={profileRef}
        show={profileOpen}
        showOverlay
        containerStyle={styles.profilePopupStyle}
        onClose={() => !passwordChangeOpen && setProfileOpen(false)}
        placement="bottom-end"
      >
        <div className={styles.profileListItemStyle}>
          <Avatar src={userData?.company_logo} label={userData?.name} />
          <p className={styles.header_userTitle}>{userData?.name}</p>
        </div>
        <div
          className={styles.profileListItemStyle}
          style={{ cursor: 'pointer' }}
          onClick={() => setPasswordChangeOpen(true)}
          ref={setPasswordChangeRef}
        >
          <Image
            image={lockDarkIcon}
            altText="change password"
            customImageContainerStyle={styles.profileIconStyle}
          />
          <p>Change password</p>
          {renderPasswordChangePopup()}
        </div>
        <div
          className={styles.profileListItemStyle}
          style={{ cursor: 'pointer' }}
        >
          <Image image={logoutIcon} altText="logout" />
          <p onClick={handleLogout}>Log out</p>
        </div>
      </PopOver>
    );
  };

  return (
    <header className={styles.header_container}>
      {renderLogoAndMenu()}
      <div className={styles.header_subContainer}>
        <div ref={setProfileRef}>
          <Avatar
            src={userData?.company_logo}
            label={userData?.name}
            imgStyle={styles.headerIconStyle}
            onClick={() => setProfileOpen(true)}
          >
            {renderProfilePopSection()}
          </Avatar>
        </div>
      </div>
    </header>
  );
};

export { Header };
